module.exports = __webpack_public_path__ + "img/IMG_20160714_151820_HDR.c7aec294.jpg";